import { render, staticRenderFns } from "./IslandPreview.vue?vue&type=template&id=1c3bc273&scoped=true&"
import script from "./IslandPreview.vue?vue&type=script&lang=js&"
export * from "./IslandPreview.vue?vue&type=script&lang=js&"
import style0 from "./IslandPreview.vue?vue&type=style&index=0&id=1c3bc273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3bc273",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3bc273')) {
      api.createRecord('1c3bc273', component.options)
    } else {
      api.reload('1c3bc273', component.options)
    }
    module.hot.accept("./IslandPreview.vue?vue&type=template&id=1c3bc273&scoped=true&", function () {
      api.rerender('1c3bc273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IslandPreview.vue"
export default component.exports